import { Typography } from '@mui/material';
import { SECTION_NAME_FONT } from 'src/constants';
import {
  IDisclaimerPosition,
  IDisclaimerWidth,
  ILayoutConfig,
} from 'src/interfaces';
import { lang, parseLayoutConfig } from 'src/utils';

import {
  DisclaimerBox,
  GridBox,
  RecommendationBox,
  ScreenBox,
} from './GenerateGridLayout.styled';

export const generateGridLayout = (
  configString: string,
  scale: number,
  isRecommendation?: boolean,
) => {
  const {
    orientation,
    rows,
    cols,
    disclaimerPosition,
    disclaimerType,
  }: ILayoutConfig = parseLayoutConfig(configString);

  const isVertical = orientation === 'vertical';
  const screenHeight = isVertical ? 1920 : 1080;
  const screenWidth = isVertical ? 1080 : 1920;

  const disclaimerHeight = isVertical ? screenHeight / 12 : screenHeight / 15;

  const gridHeight = disclaimerPosition
    ? screenHeight - disclaimerHeight
    : screenHeight;
  const gridSectionHeight = gridHeight / rows;
  const gridSectionWidth = screenWidth / cols;

  const gridSections = [...Array((isRecommendation ? 3 : rows) * cols)].map(
    (_, index) => (
      <GridBox
        key={index}
        $scale={scale}
        data-testid="gridBox"
        sx={{
          height: gridSectionHeight * scale,
          width: gridSectionWidth * scale,
        }}
      />
    ),
  );
  if (isRecommendation) {
    gridSections.push(
      <RecommendationBox
        key={gridSections.length + 1}
        data-testid="gridBox"
        sx={{
          height: gridSectionHeight * scale * 1,
          width: gridSectionWidth * scale * 3,
        }}>
        <Typography
          variant="body1"
          sx={{ fontSize: `${scale * SECTION_NAME_FONT}rem` }}>
          {lang.editLayoutsSidebar.dynamicArea}
        </Typography>
      </RecommendationBox>,
    );
  }

  let disclaimerSection = [];
  if (disclaimerPosition) {
    const disclaimerWidth =
      disclaimerType === IDisclaimerWidth.FULL
        ? screenWidth * scale
        : (screenWidth * scale) / 2;

    disclaimerSection[0] = (
      <DisclaimerBox
        data-testid="disclaimerBox"
        $scale={scale}
        sx={{
          height: disclaimerHeight * scale,
          width: disclaimerWidth,
        }}>
        <Typography
          variant="body1"
          sx={{ fontSize: `${scale * SECTION_NAME_FONT}rem` }}>
          {lang.disclaimer}
        </Typography>
      </DisclaimerBox>
    );

    disclaimerSection[1] = (
      <DisclaimerBox
        data-testid="disclaimerBox"
        $scale={scale}
        sx={{
          height: disclaimerHeight * scale,
          width: disclaimerWidth,
        }}>
        <Typography
          variant="body1"
          sx={{ fontSize: `${scale * SECTION_NAME_FONT}rem` }}>
          {lang.disclaimer}
        </Typography>
      </DisclaimerBox>
    );
  }

  return (
    <ScreenBox data-testid="screenBox">
      {disclaimerPosition === IDisclaimerPosition.TOP && disclaimerSection[0]}
      {disclaimerPosition === IDisclaimerPosition.TOP &&
        disclaimerType === IDisclaimerWidth.HALF &&
        disclaimerSection[1]}
      {gridSections}
      {disclaimerPosition === IDisclaimerPosition.BOTTOM &&
        disclaimerSection[0]}
      {disclaimerPosition === IDisclaimerPosition.BOTTOM &&
        disclaimerType === IDisclaimerWidth.HALF &&
        disclaimerSection[1]}
    </ScreenBox>
  );
};
